import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle } = FiIcons;

const WhatYouLearn = () => {
  const skills = [
    'Safe car checks and cockpit drill',
    'Moving off and stopping safely',
    'Navigating roundabouts and junctions',
    'Mastering all manoeuvres required for your test',
    'Confident driving on all road types'
  ];

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6 transition-colors">
              What You'll Learn
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 transition-colors">
              Our comprehensive curriculum covers everything you need to become a safe, confident driver.
            </p>
            <div className="space-y-4">
              {skills.map((skill, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700 dark:text-gray-300 text-lg transition-colors">{skill}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-8 border border-gray-100 dark:border-gray-700 transition-colors duration-300">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753660171750-what-you-learn.jpg"
                alt="Learning to drive"
                className="w-full h-64 object-cover rounded-xl"
              />
              <div className="mt-6 grid grid-cols-2 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600 dark:text-blue-400 transition-colors">10+</div>
                  <div className="text-sm text-gray-600 dark:text-gray-400 transition-colors">Years Experience</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600 dark:text-blue-400 transition-colors">100%</div>
                  <div className="text-sm text-gray-600 dark:text-gray-400 transition-colors">Qualified Instructors</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatYouLearn;